<template>
    <div class="row d-flex flex-column align-items-center" :class="{'opacity-50':isLoading}" v-if="subscriprionCards.length > 0">
        <div class="row pb-3 fs-large">
            <div class="col-12">
                <div class="fs-larger" :class="{'opacity-50':isLoading}">
                    Available Plugins:
                </div>
            </div>
        </div>
        
        <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12 my-3" v-for="card in subscriprionCards">
                <div class="plan-card d-flex flex-column" v-if="subscriprionCards.length > 0">
                    <div class="d-flex flex-grow-1 flex-column justify-content-between">
                        <div class="fs-largest bold prod-title">
                            <span>{{card.title}}</span>
                            <i class="fs-larger fas prod-icon" :class="card.iconClass"></i>
                        </div>
                        <span class="prod-sub-title">{{card.subTitle}}</span>
                        <div v-for="price in card.prices">
                            <p class="bold font-weight-600 prod-price">{{`${price.value} ${price.valueType} `}}<span class="prod-month font-weight-400">{{`${price.priceType}`}}</span></p>
                        </div>
                        <div class="d-flex flex-row pb-2" v-if="card.suggestions.length !== 0">
                            <div class="advice-tags">{{card.suggestions.value}}</div>
                        </div>
                    </div>
                    <div class="plan-status" :class="{'active': card.isSubcriptionActive}">{{card.isSubcriptionActive ? 'Active' : 'Inactive'}}</div>
                    
                    <button class="btn blue mt-4 mb-3 bold" @click="openSubscriptionModal(card)" v-show="!card.isSubcriptionActive && card.isAvailable">
                        <span>Available</span>
                    </button>

                    <button class="btn tertiary mt-4 mb-3 bold" @click="openSubscriptionModal(card)" v-show="card.isSubcriptionActive && card.isAvailable">
                        <span>View</span>
                    </button>

                    <button class="btn mt-4 mb-3 mx-4 prod-btn dark bold" v-tooltip.bottom="card.subscriptionBtn.tooltipInfo" v-show="!card.isAvailable">
                        <i class="fs-small fas fa-lock dark mt-1" :class="card.subscriptionBtn.iconClass"></i>
                        <span>{{card.subscriptionBtn.name}}</span>
                    </button>

                    <div class="my-2 plan-line"></div>
                    <div class="my-2 bold">{{`${card.subscriptionDetails.title}`}}</div>
                    <div v-for="info in card.subscriptionDetails.info">
                        <div class="d-flex flex-column justify-content-between prod-infos">
                            <div class="prod-info d-flex">
                                <div>
                                    <i class="fs-small fas fa-check dark"></i>
                                </div>
                                <div>
                                    <span>{{info.detail}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else class="row justify-content-center" :class="{'opacity-50':isLoading}">
                    <div class="col-6 pb-3">
                        <div class="plan-card no-info d-flex">
                            <div class="d-flex flex-grow-1 flex-row justify-content-between align-items-center">
                                <span class="fs-large bold">No subscriprions available!</span>
                                <i class="fs-largest fas fa-exclamation-circle dark"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    props: {
        subscriprionCards: {
            type: Array,
        },
        isLoading: {
            type: Boolean
        }
    },
    computed: {
        ...mapGetters([
            'getSelectedSubscription',
        ]),
        subscription() {
            return this.getSelectedSubscription;
        }
    },
    methods: {
        ...mapActions([
            'openModal',
            'setCardSubscription'
        ]),
       openSubscriptionModal(cardSubscription) {
            this.setCardSubscription(cardSubscription);
            this.openModal('Subscriptions');
       }
    },
}
</script>

<style scoped lang="scss">
    @import "~@/assets/scss/_variables.scss";
    
    p {
        padding: 0px;
        margin: 0px;
        line-height: 24px;
    }

    .plan-card {
        position: relative;
        min-height: 95px;
        max-width: 345px;
        padding: 20px;
        background: #FFFFFF;
        color: $darkest;
        box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
        border-radius: 5px;

        &.no-info {
            max-width: none;
        }
    }

    .plan-status {
        position: absolute;
        right: 0px;
        top: 0px;
        color: white;
        font-weight: 900;
        font-size: 15px;
        background-color: #c9120b;
        padding: 5px 15px;
        border-radius: 0px 5px;

        &.active {
            background-color: #3a9732;
        }
    }

    .advice-tags {
        position: relative;
        right: 0px;
        top: 2px;
        color: white;
        font-weight: 900;
        font-size: 11px;
        background-color: #787878;
        border-radius: 4px;
        padding: 1px 4px;
    }

    .prod-info {
        position: relative;
        font-size: 12px;
        padding-top: 7px;
    }

    .prod-sub-title {
        color: #787878;
        font-size: 13px;
        padding-top: 3px;
        padding-bottom: 15px;
    }

    .prod-infos {
        padding-top: 5px;
    }

    .prod-price {
        font-size: 24px;
        padding-bottom: 5px; 
    }

    .prod-month {
        font-size: 13px;
    }

    .prod-btn {
        border: solid 1px #cecece;
        background-color: white;
        border-radius: 5px;
    }

    .prod-icon {
        position: relative;
        top: -2px;
        left: 10px;
    }

    .plan-line {
        border-bottom: solid 1px #cecece;
    }
</style>



// WEBPACK FOOTER //
// SubscriptionCard.vue?f8503b1c